module.exports = __webpack_public_path__ + "img/type2.9972d64a.png";